import { trackInquiryCompleted, trackInquiryFailed, type InquiryContext } from "./inquiryTiming";

export async function runInquiry<T>(context: InquiryContext, fn: () => Promise<T>): Promise<T> {
  const startedAt = performance.now();

  try {
    const result = await fn();
    trackInquiryCompleted(context, startedAt);
    return result;
  } catch (error) {
    trackInquiryFailed(context, startedAt, error);
    throw error;
  }
}

export type { InquiryContext };
